module.exports = __webpack_public_path__ + "img/banner-clean-water.60203cfa.png";